import '../App.css';
import { useLocation } from "react-router-dom";

export default function MissingPage() {

  const location = useLocation().pathname
  console.log(location, "test")

  return (
    <div>
      <div className="logoContainer">
        <div className="logoIcon">🐍</div>
        <div className="logoText">Sneikkimies Novel Translations</div>
      </div>
    </div>
  );
}